import { SpinnerIcon } from 'shared/icons/SpinnerIcon';

interface Props {
    classNames?: string;
}

export const LoadingItem = ({ classNames }: Props) => (
    <article className={`u-text-center ${classNames || ''}`} data-testid="Hotel-resultPageLoading">
        <h3>
            Laster overnattingstilbud <SpinnerIcon className="u-ml8" size={22} />
        </h3>
    </article>
);
